// import Cookies from 'js-cookie'


const client = getCookie('native_client') || '';
let TokenKey = '';
if(client == 'android' || client == 'ios' || client ==  'pad'){
  TokenKey = 'native_token'
}else{
  TokenKey = 'token'
}

export function getToken() {
  function getCookie(cname) {
    var name = cname + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim()
      if (c.indexOf(name) === 0) return c.substring(name.length, c.length)
    }
    return ''
  }
  const cookie_val = getCookie(TokenKey)
  return cookie_val
}

export function getCookie(cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim()
    if (c.indexOf(name) === 0) return c.substring(name.length, c.length)
  }
  if (process.env.NODE_ENV === 'development' && cname == 'organSign') {
    return 'ZHL00000272'
  }
  return ''
}

export function setToken(token) {
  return localStorage.setItem(TokenKey, token)
  // return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(TokenKey)
  // return Cookies.remove(TokenKey)
}
// 获取用户名
export function getCurrentName() {
  let currLoginUser = localStorage.getItem('currLoginUser')
  try {
    currLoginUser = JSON.parse(currLoginUser)
  } catch (_) {
    currLoginUser = {}
  }
  return currLoginUser['name']
}
// 获取机构号
export function getOrganSign() {
  let currLoginUser = localStorage.getItem('currLoginUser')
  try {
    currLoginUser = JSON.parse(currLoginUser)
  } catch (_) {
    currLoginUser = {}
  }
  return currLoginUser['organSign']
}

// 获取问诊来源 ,默认0，海典15
export function getSource() {
  let source = localStorage.getItem('sourceId')
  return source ? source : '0'
}
